import { useState, useEffect } from "react";
import CourseProposalRepository from "../../../Repositories/CourseProposalRepository";

export interface FetchCourseProposal {
  id: number;
  teacherId: number | undefined;
  teacherName: string;
  startDatetime: string;
  endDatetime: string;
  description?: string;
  isRemote: boolean;
  isCourseInTheHour: boolean;
  duration?: number;
  creationDatetime?: Date;
  priceRate: number;
  finalTotal: number;
  averageNote: any;
  isAccepted: boolean;
  isRefused: boolean;
}

export const useCourseProposals = (
  punctualId: number,
  load: boolean,
  setLoad: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const [proposals, setProposals] = useState<FetchCourseProposal[]>([]);

  useEffect(() => {
    if (load) return;

    CourseProposalRepository.getCourseProposals(punctualId)
      .then((collection) => {
        const mapped = collection.map((p: any) => {
          const start = new Date(p.startDatetime);
          const end = new Date(p.endDatetime);
          const durationHours =
            (end.getTime() - start.getTime()) / (1000 * 60 * 60);

          const finalTotal = p.teachrPrice * durationHours;
          return {
            id: p.id,
            teacherId: p.teachr_id,
            teacherName: p.teachr_full_name || "-",
            startDatetime: p.startDatetime,
            endDatetime: p.endDatetime,
            message: p.message,
            description: p.description,
            isRemote: p.isRemote ?? false,
            isCourseInTheHour: p.isCourseInTheHour ?? false,
            duration: p.duration,
            creationDatetime: p.creationDatetime,
            priceRate: p.teachrPrice,
            finalTotal,
            averageNote: p.averageNote ?? null,
            isAccepted: p.isAccepted ?? false,
            isRefused: p.isRefused ?? false,
          };
        });

        setProposals(mapped);
        setLoad(false);
      })
      .catch(() => setLoad(false));
  }, [punctualId, load, setLoad]);

  return proposals;
};
